import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
import * as tokens from '@ingka/variables/design-tokens';
export default class DesignCardStyle {
    static getStyle() {
        return css `
			${Text.CSS}

			:host {
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.container {
				width: 100%;
				display: flex;
				flex-direction: column;
				overflow: hidden;
				cursor: pointer;
				box-shadow: ${tokens.shadowSizeDefault};
				border-radius: ${tokens.radiusS};
				outline: none;
				position: relative;
			}
			.container[aria-disabled='true'] {
				cursor: progress;
			}
			.outline {
				position: absolute;
				pointer-events: none;
				opacity: 0;
				box-shadow: 0 0 0 ${tokens.thicknessThick};
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				border-radius: ${tokens.radiusS};
				transition-property: opacity, top, left, right, bottom;
				transition-duration: ${tokens.delayEmphasised};
			}
			.container:focus-visible {
				overflow: unset;
			}
			.container:focus-visible .outline {
				opacity: 1;
				top: -${tokens.space25};
				left: -${tokens.space25};
				right: -${tokens.space25};
				bottom: -${tokens.space25};
			}

			.content-container {
				display: flex;
				flex-direction: column;
				height: 100%;
				width: 100%;
				position: relative;
				transition: height 0.2s;
			}
			.image-container {
				height: 100%;
				width: 100%;
				aspect-ratio: 4 / 3;
				opacity: 1;
				transition: opacity 0.2s;
				overflow: hidden;
			}
			.image {
				height: 100%;
				width: 100%;
				object-fit: cover;
				border-top-left-radius: ${tokens.radiusS};
				border-top-right-radius: ${tokens.radiusS};
				opacity: 1;
				transition:
					transform 0.4s ease,
					opacity 0.2s;
			}
			.container:hover .image {
				transform: scale(1.035);
			}
			.container:hover .footer-image {
				transform: scale(1.035);
			}
			.relative {
				position: relative;
			}
			.footer-image-size {
				height: ${tokens.space550};
				width: ${tokens.space550};
			}

			.footer-image {
				transition: transform 0.4s ease;
				max-width: initial;
			}
			.loading-ball-container {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				display: flex;
				justify-content: center;
				align-items: center;
			}
			.footer {
				display: flex;
				align-items: center;
				width: 100%;
				height: ${tokens.space550};
			}
			.full-width {
				width: 100%;
			}
			.text-container {
				width: calc(100% - ${tokens.space550});
				padding-left: ${tokens.space125};
				padding-right: ${tokens.space125};
			}
			.title {
				margin: 0;
			}
			.subtitle {
				margin: 0;
			}
			.truncate {
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
				max-width: 100%;
			}
			skapa-image {
				height: 100%;
				display: flex;
				width: inherit;
				padding-bottom: 0;
			}
			.invisible {
				opacity: 0;
			}
			::slotted([slot='card-footer-content']) {
				max-width: 100%;
			}
		`;
    }
}
//# sourceMappingURL=DesignCardStyle.js.map